import { useState } from "react";

export default function useFilters() {
  const [checkedValues, setCheckedValues] = useState<any[]>([]);

  function handleSelect(list: string[]) {
    setCheckedValues(
      list
    );
  }

  return { handleSelect, checkedValues };
}
